import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../../../store/actions/notificationAction';

import ApiResponse from '../../../../../models/ApiResponse';
import ResponseError from '../../../../../models/ResponseError';

interface GhaManualEntryImportContainerProps {
  receiveError: Function;
};

interface GhaManualEntryImportContainerState {
 
};

class GhaManualEntryImportContainer extends Component<GhaManualEntryImportContainerProps, GhaManualEntryImportContainerState> {

  state: GhaManualEntryImportContainerState = {
    
  }

  componentDidMount() {

   
  };

  
  

  render () {

    return (
      <div>I am container</div>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};
  
export default connect(null, mapDispatchToProps)(GhaManualEntryImportContainer);